import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class FieldGoalStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            FootballState.FieldGoal === fragment.associatedState &&
            (play.historyContains(FootballState.FieldGoalGood) ||
                play.historyContains(FootballState.FieldGoalMissed) ||
                play.historyContains(FootballState.FieldGoalFumble) ||
                play.historyContains(FootballState.FieldGoalBlocked)) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const fgGoodFragment = play.getFirstFragment(
            FootballState.FieldGoalGood
        );
        const rougeFragment = play.getFirstFragment(FootballState.Rouge);
        const fieldGoalFragment = play.getFirstFragment(
            FootballState.FieldGoal
        );
        const { kickedBy, kickedFrom, id } =
            play.getFirstFragment(FootballState.Kick) ||
            play.getFirstFragment(FootballState.PatKick) ||
            {};

        let yardsKicked = 0;
        if (fgGoodFragment || rougeFragment) {
            yardsKicked = this.getYardsKicked(gameContext, kickedFrom);
        }

        const stats = [];

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: kickedBy?.teamId,
                playerId: kickedBy?.id,
                driveId: gameContext.currentDriveId,
                fragmentId: id,
                category: FootballStatsCategory.FIELD_GOAL,
                values: {
                    completed: fgGoodFragment ? 1 : 0,
                    attempted: 1,
                    yards: yardsKicked,
                    rouge: rougeFragment ? 1 : 0,
                    dropKick: fieldGoalFragment?.isDropKick ? 1 : 0
                }
            },
            stats
        );

        const contextSnapshot = play.getContextSnapshot();

        if (
            (contextSnapshot.homeTeamHasPossession
                ? gameContext.gameConfig.general.fieldLength
                : 0) -
                contextSnapshot.fieldPosition *
                    gameContext.getFieldDirectionMultiplier() <=
            gameContext.gameConfig.general.redZoneLength
        ) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: kickedBy?.teamId,
                    playerId: kickedBy?.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: id,
                    category: FootballStatsCategory.FIELD_GOAL_REDZONE,
                    values: {
                        completed: fgGoodFragment ? 1 : 0,
                        attempted: 1,
                        yards: yardsKicked
                    }
                },
                stats
            );
        }

        return stats;
    }

    getYardsKicked(gameContext, kickSpot) {
        return (
            ((gameContext?.homeTeamHasPossession
                ? gameContext?.getFieldLength()
                : 0) -
                kickSpot) *
                gameContext.getFieldDirectionMultiplier() +
            gameContext?.gameConfig?.general?.endZoneLength
        );
    }
}
